import script from "./ProductVariantsPanel.vue?vue&type=script&setup=true&lang=js"
export * from "./ProductVariantsPanel.vue?vue&type=script&setup=true&lang=js"

import "./ProductVariantsPanel.vue?vue&type=style&index=0&id=452b52e3&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-452b52e3"]])

export default __exports__